<template>
  <div class="pairedForms">
    <div class="form__half">
      <tooltip v-show="filedErrors.hasOwnProperty('unit_type')" class="form__validation">
        {{ $t('errors.field_required') }}
      </tooltip>
      <div class="label">{{ $t('ticket_types.unit_type') }} *</div>
      <input type="text" class="w95" name="unitType"
             @focusout="setTicketData('unit_type', $event.target.value)"
             :value="subData ? subData.unit_type : ''"
      />
    </div>
    <div class="form__half ar">
      <tooltip v-show="filedErrors.hasOwnProperty('unit_price')" class="form__validation">
        {{ $t('errors.field_required') }}
      </tooltip>
      <div class="label w95">{{ $t('ticket_types.unit_price') }} *</div>
      <input type="text" class="w95" name="unitPrice"
             @focusout="setTicketData('unit_price', $event.target.value)"
             :value="subData ? subData.unit_price/100 : ''"
      />
    </div>
  </div>
</template>

<script>

import '../../styles.scss'
import {storeMixin} from '../../mixins/storeMixin.js'
import {mapGetters} from "vuex";
import Tooltip from "../../../../common/Tooltip";

export default {
  mixins: [storeMixin],
  props: ['subData'],
  components: {
    Tooltip
  },
  computed: {
    ...mapGetters({
      filedErrors: 'tenants/ticketTypes/filedErrors',
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/ExtraFields/picker.vue